<template>
  <ion-page id="accountmenu-page">
    <ion-content>

      <div v-if="showState == SHOW_EXPLAINTOUR">
          <ExplainTour :screen="explainTourScreen"
                  :wordsSpoken="explainTourWordsSpoken"
                  :wordsSpokenTrigger="explainTourWordsSpokenTrigger"
                @toolbar-click="explainTourToolbarClick" />
      </div>

      <div v-show="showState == SHOW_MENU">
        <TopLine :style="styleTopline" :title="accountMenuString" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>

        <ion-list id="account-menu" :style="styleMiddle">

        <ion-item v-if="dummyRef != 0">
          <ion-label @click="onClick('route','/login')">
            {{ translateEnglishWords("Sign in") }}
          </ion-label>
        </ion-item>
        <ion-item v-if="dummyRef != 0">
          <ion-label @click="onClick('route','/register')">
            {{ translateEnglishWords("Register") }}
          </ion-label>
        </ion-item>
        <ion-item v-if="dummyRef == 0">
          <ion-label @click="onClick('route','/logoff')">
            {{ translateEnglishWords("Sign off") }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label @click="onClick('route','/boardpreferences')">
            {{ translateEnglishWords("Board & Play Preferences") }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label @click="onClick('route','/voicesmenu')">
            {{ translateEnglishWords("Language , Voice Selection & Recognizer Practice") }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label @click="onClick('route','/cancel')">
            {{ translateEnglishWords("Cancel Subscription") }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label @click="onClick('route','/delete_account')">
            {{ translateEnglishWords("Delete Account") }}
          </ion-label>
        </ion-item>


        <ion-item>
          <ion-label @click="onClick('list','contact')">
            {{ translateEnglishWords("Contact") }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label @click="onClick('list','terms')">
            {{ translatePhrase("Terms of Service") }}
          </ion-label>
        </ion-item>
      </ion-list>
      <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
    </div>
  </ion-content>
</ion-page>


</template>

<script setup>

  import { IonPage, IonContent,IonList,IonItem,IonLabel  } from '@ionic/vue';
  import { computed } from "@vue/reactivity"

  import { ref, watch } from 'vue'
  import ExplainTour from '@/components/ExplainTour.vue'
  import ToolBar from '@/components/ToolBar.vue'
  import TopLine from '@/components/TopLine.vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { useGetData, generateErrorAlertText } from '../../composables/getData.js'
  import { parseWordsSaid , buildWordListFromChoiceList } from '@/composables/wordlistSupport.js'
  import SingleOption from '@/components/SingleOption.vue'

  import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, scrollElement,
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
  import { translateEnglishWords , translatePhrase } from '@/composables/translation.js';

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
        wordsSaid : {
          type : String,
          default : ""
        },
        wordsSaidTrigger : {
          type : Number,
          default : 0
        }
      })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const dummyRef = ref(connectionStore.getDummy)
  const isDark = ref(connectionStore.getDarkmode != "light")
  const coordinate = ref(connectionStore.getCoordinateLocation)
  
  const accountMenuString = translatePhrase("Account Menu")

  const wordlistTrigger = ref(0)

  const wordlistMenu = "command log sign in register off contact terms board language explain ignore done cancel delete mute listen scroll down up";
  
  const wordlist = ref(wordlistMenu)
  emit("word-list",wordlist.value)

  const explainTourWordsSpoken = ref("")
  const explainTourScreen = ref("")
  const explainTourWordsSpokenTrigger = ref(0)

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

  const SHOW_MENU = 0
  const SHOW_EXPLAINTOUR = 1
  
  const showState = ref(SHOW_MENU)

  const TOOLBAR_EXPLAIN = 0

  const toolbarElements = ref([
    { index : TOOLBAR_EXPLAIN, label : translateEnglishWords("Explain") ,disabled : false}
  ])
  const toolbarTrigger = ref(0)

  doStartupCheck(true,afterStartupCallbackRoutine)

   watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

   watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

  function afterStartupCallbackRoutine(stuffChanged) {
    dummyRef.value = connectionStore.getDummy
  }

  function onClick(clickType,option) {
    //console.log("################### Click ",clickType,option)

    if (clickType == 'route') {
      emit("where-next",option)

      //router.replace({ path: option })
      return
    }

    switch (option) {
      case "contact" :
        explainTourInitialize("contact",null)
        break;
      case "terms" :
        explainTourInitialize("terms_of_service",null)
        break;
    }
  }

  // START Explain Tour Routines

  function explainTourInitialize(page,html) {
    showState.value = SHOW_EXPLAINTOUR
    explainTourScreen.value =  (page != null) ? page : html;
    wordlist.value = connectionStore.getExplainTourWords
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
  }

  function explainTourToolbarClick(whatClicked) {
    switch (whatClicked) {

      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "done" :
        showState.value = SHOW_MENU
        wordlist.value = wordlistMenu
        emit("word-list",wordlist.value)
        wordlistTrigger.value++
        break
    }
  }

  // END Explain Tour Routines

  function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

  function toolbarClick(arrayIndex) {
      processWords("command explain")
  }

function processWords(text) {
  //console.log("text in Account Menu ",text)

  var returnArray = []

  switch (showState.value) {
    case SHOW_EXPLAINTOUR :
      explainTourWordsSpoken.value = text
      explainTourWordsSpokenTrigger.value++
      break;
    case SHOW_MENU :
      returnArray = parseWordsSaid(text,parseMenuCommands)
      //console.log("menu command found",returnArray)
      switch (returnArray[0]) {
        case "scroll" :
          scrollElement("account-menu",returnArray[1])
          break
        case "explain" :
          explainTourInitialize("account_menu",null)
          break
        case "mute" :
          microphoneIsMuted.value = true 
         emit("mic-is-muted",microphoneIsMuted.value)
         connectionStore.setMicrophoneIsMuted(true)
          break
        case "listen" :
          microphoneIsMuted.value = false 
          emit("mic-is-muted",microphoneIsMuted.value)
          connectionStore.setMicrophoneIsMuted(false)
          break
        case "contact" :
          explainTourInitialize("contact",null)
          break
        case "terms" :
          explainTourInitialize("terms_of_service",null)
          break
        case "cancel" :
          emit("where-next","/cancel")
          break
        case "delete" :
          emit("where-next","/delete_account")
          break
        case "login" :
          emit("where-next","/login")
          break         
       case "logoff" :
          emit("where-next","/logoff")
          break 
       case "register" :
          emit("where-next","/register")
          break 
       case "language" :
          emit("where-next","/voicesmenu")
          break
        case "board" :
          emit("where-next","/boardpreferences")
          break
        case "done" :
          emit("where-next","/")
          //router.replace({ path: "/"})
          break
      }
      break
  }
}
  
function parseMenuCommands(words,currentWordIndex) {
  
  //console.log("in parse menu commands",words,currentWordIndex)
  var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
  var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
  var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

  for (var i = 0; i < words.length; i++) {
      if (currentWord == "ignore" || currentWord == "explain" || currentWord == "done" 
              || currentWord == "mute" || currentWord == "listen")
          return [currentWord,""];
      if (currentWord == "scroll") {
          if (nextWord == "up") {
              return ["scroll", "up"]
          }
          if (nextWord == "down") {
              return ["scroll", "down"]
          }
      }
      if (currentWord == "log" || currentWord == "sign") {
        if (nextWord == "in")
          return ["login",""]
        if (nextWord == "off")
          return ["logoff",""]
      }
      if (currentWord == "register")
        return ["register",""]
      if (currentWord == "board")
        return ["board",""]
      if (currentWord == "language")
        return ["language",""]
      if (currentWord == "contact")
        return ["contact",""]
      if (currentWord == "cancel")
        return ["cancel",""]
     if (currentWord == "delete")
        return ["delete",""]
      if (currentWord == "terms")
        return ["terms",""]
      currentWord = nextWord;
      nextWord = nextNextWord;
      nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
  }
  return ["ignore",""];
}

</script>

<style scoped>

ion-label {
    cursor: pointer;
 }


</style>